<template>
  <div v-if="Object.keys(groups).length !== 0" class="col-selector col" :class="colLayout">
    <vue-scroll :ops="{ bar: { background: '#4283e366' } }">
      <template v-if="colLayout == 'groupped'">
        <div v-for="(group, groupName) in groups" :key="groupName" class="col-group">
          <div class="col-group__name">{{ groupName }}</div>
          <div class="col-group__content">
            <div
              v-for="(item, i) in group.sort((a, b) => (a.label.en < b.label.en ? -1 : 1))"
              :key="i"
              v-tooltip="{
                content:
                  item.disabled || item.id === 0
                    ? 'Compare criteria do not match. Try comparing by country.'
                    : null,
                classes: ['disabled-on-flip'],
              }"
              class="col-item"
              :class="{
                selected: selected === item.id,
                disabled: item.id === 0 || item.disabled === true,
              }"
              @click="select(item)"
            >
              <slot name="groupped" :item="item">{{ item.label[lng] }}</slot>
            </div>
          </div>
        </div>
      </template>
      <template v-if="colLayout !== 'groupped'">
        <div class="col-selector__content">
          <div
            v-for="item in items"
            :key="item.id"
            class="col-item"
            :class="{
              selected: isSelected(item),
              disabled: item.id === 0,
            }"
            @click="select(item)"
          >
            <slot>{{ item.label[lng] }}</slot>
          </div>
        </div>
      </template>
    </vue-scroll>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'selected',
    event: 'select',
  },
  props: ['title', 'items', 'selected', 'colLayout', 'appSlot'],
  computed: {
    lng() {
      return this.$route.params.lng
    },
    groups() {
      return this.items.reduce((acum, item) => {
        let group = (item.group !== void 0 && item.group[this.lng]) || 'default'
        acum[group] = acum[group] || []
        acum[group].push(item)
        return acum
      }, {})
    },
    cubeMetaId() {
      return this.$store.state.query[this.appSlot + 'CubeId'];
    },
  },
  methods: {
    select(item) {
      if (item.id === 0 || item.disabled === true) return
      const isSelected = this.isSelected(item)
      if (this.metaId && isSelected) return
      if (isSelected) this.$emit('select', null)
      else this.$emit('select', item.id)
    },
    isSelected(item) {
      return (
        this.selected === item.id ||
        (item.metaId && this.selected === item.metaId && this.cubeMetaId === item.cubeMetaId)
      )
    },
  },
}
</script>

<style lang="stylus">
.col-selector
  position: relative
  flex: 1
  display: flex
  flex-direction: column
  width: 100%
  height: 100%
  background-color: #fff
  overflow-y: auto
  overscroll-behavior-y: contain

  &.tags
    flex: 0 1 auto
    padding: vw(15px) vw(15px) vw(10px)

    .col-selector__content
      max-height: 30vh

    .mobile &
      .col-selector__content
        max-height: 20vh

      +m-breakpoint(landscape)
        padding: vh(15px) vw(15px)

        .col-selector__content
          display: inline-flex

    .col-item
      m-font-size(12, 16)
      display: inline-flex
      margin-right: vw(10px)
      margin-bottom: vw(10px)
      padding: vw(2px) vw(4px)
      border-radius: 5px
      background-color: rgba($green, 0.2)
      color: $green
      cursor: pointer
      white-space: nowrap

      .mobile &
        font-size: 0.65em
        line-height: 1.35
        margin-bottom: vw(5px)
        margin-right: vw(7.5px)

        +m-breakpoint(landscape)
          margin-bottom: vh(10px)
          margin-right: vw(5px)

      &.disabled
        cursor: default

      &:hover:not(.disabled)
        background-color: rgba($green, 0.5)

      &.selected
        background-color: $green
        color: #fff

  &.indicators
    .col-item
      m-font-size(14, 18)
      padding: vw(15px) vw(50px) vw(15px) vw(20px)
      border-bottom: 1px solid $gray
      color: $blue
      cursor: pointer

      .mobile &
        font-size: 0.8em
        line-height: 1.25

        +m-breakpoint(landscape)
          padding: vh(10px) vw(25px) vh(10px) vw(10px)

      &.disabled
        cursor: default

      &:hover:not(.disabled)
        background-color: rgba($havelock-blue, 0.1)
        color: $blue-2

      &.selected
        background-color: rgba($havelock-blue, 0.75)
        color: #fff
        cursor: default

        &:hover:not(.disabled)
          color: #fff
          background-color: rgba($havelock-blue, 0.75)

.col-group
  border-bottom: 1px solid $blue

.col-group__name
  m-font-size(12, 16)
  padding: vw(6px) vw(20px)
  color: $black

  .mobile &
    font-size: 0.7em

    +m-breakpoint(landscape)
      padding: vh(5px) vw(10px)

.col-group__content
  display: flex
  flex-wrap: wrap
  width: 100%

  .col-item
    flex: 0 0 percentage((1 / 2))
    padding: vw(15px)
    border: 1px solid $gray
    cursor: pointer

    .mobile &
      +m-breakpoint(landscape)
        padding: vh(20px)

    &:nth-child(odd),
    &:nth-child(even)
      border-left: none

    &:nth-child(even)
      border-right: none

    &:nth-child(n+3)
      border-top: none

    &:nth-last-child(1)
      border-bottom: none

    &:nth-last-child(2)
      &:not(:nth-child(even))
        border-bottom: none

    &:hover
      background-color: rgba($havelock-blue, 0.05)

    &.selected
      background-color: rgba($havelock-blue, 0.1)
      color: $blue
      cursor: default

.col-item.disabled
  cursor: default
  filter: grayscale(1)
  opacity: .4

  &:hover
    background-color: revert
</style>
